export default __webpack_public_path__ + "static/media/cook3.0341fa54.PNG";